module.exports = __webpack_public_path__ + "static/media/longboard.0fdf1b96.jpg";